import React, { useState } from 'react'
import CustomInput from '../../../components/CustomInput'
import DefaultTooltip from '../../../components/DefaultTooltip';
import QuestionIcon16pxSvg from '../../../assets/images/icons/QuestionIcon16pxSvg';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { ControlpanelErrorButton } from '../../../components/StyledButton';
import CloseIcon from '@mui/icons-material/Close';

const ExternalExecutetable = (props) => {
    const initialFormData = {
        executetableName: "",
        executetablePath: "",
        triggerOn: {
            checkIn: true,
            checkOut: false,
            access: false,
            unidentified: false
        },
        parameter: {
            event: false,
            sequenceId: false,
            timeStamp: false,
            userReference: false,
            userName: false,
            shiftCode: false,
            location: false,
            userStatus: false,
            address: false,
            peripheralCode: false
        }
    };

    const [validationMessages, setValidationMessages] = useState({
        executetableName: "",
        executetablePath: "",
    });

    const [isError, setIsError] = useState({

        executetableName: false,
        executetablePath: false,
    })

    const [isSuccess, setIsSuccess] = useState({
        executetableName: false,
        executetablePath: false,
    })

    const [formData, setFormData] = useState(initialFormData)

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => {
            let updatedData = {
                ...prevData,
                [name]: value,
            };
            return updatedData;
        });
    }

    const handleCheckedChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prevData) => {
            if (name in prevData.parameter) {
                return {
                    ...prevData,
                    parameter: {
                        ...prevData.parameter,
                        [name]: checked,
                    }
                };
            } else if (name in prevData.triggerOn) {
                return {
                    ...prevData,
                    triggerOn: {
                        ...prevData.triggerOn,
                        [name]: checked,
                    }
                };
            } else {
                return {
                    ...prevData,
                    [name]: checked,
                };
            }
        });
    };

    const triggerOnData = [
        { checked: formData.triggerOn.checkIn, name: "checkIn", label: "Check-in" },
        { checked: formData.triggerOn.checkOut, name: "checkOut", label: "Check-out" },
        { checked: formData.triggerOn.access, name: "access", label: "Access" },
        { checked: formData.triggerOn.unidentified, name: "unidentified", label: "Unidentified" }
    ]

    const parameterData = [
        { checked: formData.parameter.event, name: "event", label: "Event" },
        { checked: formData.parameter.sequenceId, name: "sequenceId", label: "Sequence ID" },
        { checked: formData.parameter.timeStamp, name: "timeStamp", label: "Timestamp" },
        { checked: formData.parameter.userReference, name: "userReference", label: "User reference" },
        { checked: formData.parameter.userName, name: "userName", label: "User name" },
        { checked: formData.parameter.shiftCode, name: "shiftCode", label: "Shift code" },
        { checked: formData.parameter.location, name: "location", label: "Location" },
        { checked: formData.parameter.userStatus, name: "userStatus", label: "User Status" },
        { checked: formData.parameter.address, name: "address", label: "Address" },
        { checked: formData.parameter.peripheralCode, name: "peripheralCode", label: "Peripheral Code" }
    ]

    return (
        <div>
            <div className='border border-[#E5E7EB] px-5 pb-2 mt-5 rounded-[4px] grid grid-cols-12 gap-x-10 gap-y-5'>
                <div className='col-span-6'>
                    <CustomInput
                        required={true}
                        title="Name"
                        inputType="text"
                        name="executetableName"
                        // isError={isEmailError}
                        // isSuccess={isEmailSuccess}
                        placeholder="Name"
                        message={validationMessages.executetableName}
                        handleInputChange={handleInputChange}
                        value={formData.executetableName}
                    />
                </div>
                <div className='col-span-6'>
                    <label className="flex items-center text-sm pt-4 pb-2">
                        Executetable path
                        <span className='text-[#EF4444] ml-1'>*</span>
                        <span className='ml-1'>
                            <DefaultTooltip
                                readMore={false}
                                title="Executable path"
                                content={
                                    <div className='flex flex-col gap-3'>
                                        <p>This maybe a path to executetable or HTTP URL</p>
                                    </div>
                                }>
                                <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                            </DefaultTooltip>
                        </span>
                    </label>
                    <CustomInput
                        labelEnable={false}
                        required={true}
                        inputType="text"
                        name="executetablePath"
                        // isError={isEmailError}
                        // isSuccess={isEmailSuccess}
                        placeholder="Path"
                        message={validationMessages.executetablePath}
                        handleInputChange={handleInputChange}
                        value={formData.executetablePath}
                    />
                </div>
                <div className='col-span-6'>
                    <div className='flex items-center gap-2'>
                        <p>Trigger on</p>
                        <DefaultTooltip
                            readMore={true}
                            title="Trigger on"
                            content={
                                <div className='flex flex-col gap-3'>
                                    <p>Execute the external program or call on selected events.</p>
                                </div>
                            }>
                            <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                        </DefaultTooltip>
                    </div>
                    <FormGroup>
                        {triggerOnData.map((trigger, index) => (
                            <FormControlLabel
                                key={index}
                                control={
                                    <Checkbox checked={trigger.checked}
                                        onChange={handleCheckedChange}
                                        name={trigger.name}
                                        disableRipple
                                    />
                                }
                                label={trigger.label}
                            />
                        ))}
                    </FormGroup>
                </div>
                <div className='col-span-6'>
                    <div className='flex items-center gap-2'>
                        <p>Parameter</p>
                        <DefaultTooltip
                            readMore={true}
                            title="Parameter"
                            content={
                                <div className='flex flex-col gap-3'>
                                    <p>Parameters to be passed from client app to external executable.</p>
                                </div>
                            }>
                            <QuestionIcon16pxSvg className="fill-[#BDBDBD]" />
                        </DefaultTooltip>
                    </div>
                    <FormGroup>
                        {parameterData.map((parameter, index) => (
                            <FormControlLabel
                                key={index}
                                control={
                                    <Checkbox checked={parameter.checked}
                                        onChange={handleCheckedChange}
                                        name={parameter.name}
                                        disableRipple
                                    />
                                }
                                label={parameter.label}
                            />
                        ))}
                    </FormGroup>
                </div>
            </div>
            <div className='flex justify-end pt-5'>
                <ControlpanelErrorButton disableRipple onClick={props.onRemove}>
                    <CloseIcon />
                    <p>Remove</p>
                </ControlpanelErrorButton>
            </div>
        </div>
    )
}

export default ExternalExecutetable